import { render, staticRenderFns } from "./TqBeacon.vue?vue&type=template&id=b85cd83c&scoped=true&"
import script from "./TqBeacon.vue?vue&type=script&lang=js&"
export * from "./TqBeacon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85cd83c",
  null
  
)

export default component.exports